import { ParkingEvents } from '@aggregator/core';
import { enumToDescriptedArray } from '@shared/core';
import { FormFieldType, FormGroupDirectionType, IFormGroupConfig } from '@shared/ui';

export const parkingEventsFormConfig = (operatorId: string): IFormGroupConfig =>
  <IFormGroupConfig>{
    type: FormFieldType.GROUP,
    fields: {
      parkingId: {
        type: FormFieldType.SELECT,
        label: 'Парковка:',
        placeholder: 'Укажите парковку',
        optionValueField: 'externalId',
        optionLabelField: 'name',
        requestUrl: 'parkings?operatorId=' + operatorId,
      },
      eventType: {
        type: FormFieldType.SELECT,
        label: 'Тип собития:',
        placeholder: 'Укажите статус',
        options: enumToDescriptedArray(ParkingEvents),
        optionLabelField: 'description',
        optionValueField: 'id',
      },
      row1: {
        type: FormFieldType.GROUP,
        direction: FormGroupDirectionType.ROW,
        forWrapping: true,
        fields: {
          freeSpotsCount: {
            type: FormFieldType.INPUT,
            label: 'Количество свабодных мест:',
            placeholder: 'Введите количество',
          },
          stateLicencePlate: {
            type: FormFieldType.INPUT,
            label: 'Номер машины',
            placeholder: 'Введите номер машины',
          },
        },
      },
      eventTimestamp: {
        type: FormFieldType.DATE,
        label: 'Время',
        placeholder: 'укажите время',
      },
    },
  };
